import { render, staticRenderFns } from "./EtapaFormacaoAcademica.vue?vue&type=template&id=2e56c510&scoped=true"
import script from "./EtapaFormacaoAcademica.vue?vue&type=script&lang=js"
export * from "./EtapaFormacaoAcademica.vue?vue&type=script&lang=js"
import style0 from "./EtapaFormacaoAcademica.vue?vue&type=style&index=0&id=2e56c510&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e56c510",
  null
  
)

export default component.exports